import { sanitizeStoredLoginUser } from '@/utils/loginUserInfo'

// 必须是 main.js 的第一个 import。这里已经不像旧版那样清 cookie，不存在"被谁在
// 模块求值时抢先读到"的具体竞态——这条排序纯粹是防御性的：把可能带凭据的脏数据
// 尽早清掉，晚清不会更安全，没有理由往后拖。

// 旧版这里还清理过 `username` / `password` 两条明文密码 cookie —— 登录页曾用
// path=/、15 天有效期把管理员账号密码明文写进去，公开站上的第三方广告脚本能用
// document.cookie 直接读到。这次迁移把这两行删掉，不是漏做：它们是
// yepsavings.com 上的 host-only cookie，迁移后本应用跑在 admin.yepsavings.com，
// 物理上够不着——留着只是一段执行了也没有效果的死代码。改由 /ecom/ 上的中转页
// 清理（JS 直接操作 document.cookie，不依赖响应头能否穿透 CDN；那之后中转页是
// 唯一还能碰到 yepsavings.com 这几条遗留 cookie 的地方）。

// 登录接口曾把完整 UmsAdmin（含密码 BCrypt hash、email、mobile）返回给前端并整个存进
// localStorage，公开站上的第三方脚本读得到——但那份存量留在 yepsavings.com 上。
// 迁移之后 admin.yepsavings.com 是全新 origin，这里的 sanitizeStoredLoginUser()
// 是 no-op（写入路径 store/modules/user.js 早就用 pickLoginUserFields 存白名单
// 四字段，新 origin 上从来没有脏数据可清）；留着是防将来写入路径又退化回整个
// 对象。真正清 yepsavings.com 那份存量的是 /ecom/ 中转页里的 JS。
sanitizeStoredLoginUser()
